module.exports = __webpack_public_path__ + "img/11.5f494819.png";